import { useNavigate, useParams } from "react-router";
import { SentimentTable } from "./components/SentimentTable";

interface ViewSentimentProps {
    onBack: () => void;
}

export const ViewSentiment = ({ onBack }: ViewSentimentProps) => {
    const { id } = useParams();
    const navigate = useNavigate();
    return (
        <>
            <SentimentTable />
            <div> We're on the sentiment page</div>
        </>
    )
}